import {FC, useState} from "react";
import {Container, ImageWrapper, OpenedDescriptionContainer} from "./styles";
import ArrowDownIcon from "../../assets/icons/arrow-down.svg";
import {ITypeRadar} from "../../types";
import ReactMarkdown from "react-markdown";
import IconUrl from "../../assets/icons/link-out-bold.svg";

interface Iprops {
  data: React.ReactNode;
  title?: React.ReactNode;
  isOpen?: boolean;
  typeRadar?: ITypeRadar;
  url?: string;
}

export const BlockToggleGrayArrow: FC<Iprops> = ({
  data,
  title,
  isOpen = false,
  typeRadar,
  url,
}) => {
  const [isOpenBlockDesc, setIsOpenBlockDesc] = useState<boolean>(isOpen);
  const toggleDescription = () => {
    setIsOpenBlockDesc((prev) => !prev);
  };
  return (
    <Container
      style={{
        border: "1 px solid rgba(255, 255, 255, 0.2)",
        backgroundColor: "#22272B",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
        }}
      >
        <div
          style={{color: "#ffffff", fontSize: 16, textTransform: "uppercase"}}
        >
          {title}
        </div>
        <ImageWrapper onClick={toggleDescription}>
          {isOpenBlockDesc ? (
            <img
              src={ArrowDownIcon}
              alt="Toggle icon"
              style={{transform: "rotate(180deg)"}}
            />
          ) : (
            <img src={ArrowDownIcon} alt="Toggle icon" />
          )}
        </ImageWrapper>
      </div>
      {isOpenBlockDesc && (
        <OpenedDescriptionContainer style={{gap: 12}}>
          {typeof data === "string" ? (
            <div style={{color: "white"}}>
              <ReactMarkdown>{data}</ReactMarkdown>

              {url && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: 20,
                  }}
                >
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#71c6fa",
                      fontWeight: "400",
                      textDecoration: "none",
                    }}
                  >
                    Ссылка на кейс
                  </a>
                  <img src={IconUrl} alt="" />
                </div>
              )}
            </div>
          ) : (
            data
          )}
        </OpenedDescriptionContainer>
      )}
    </Container>
  );
};
